"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "processHeaderItemsForPlatform", {
    enumerable: true,
    get: function() {
        return processHeaderItemsForPlatform;
    }
});
function processHeaderItemsForPlatform(_children, _placement, _colors) {
    return null;
}

//# sourceMappingURL=processHeaderItemsForPlatform.js.map
